<template>
  <v-container>
    <v-card height="200" class="py-10">
      <v-row>
        <v-col cols="10">
          <h3 class="mx-10">
            Оюутан:
            <span v-if="selectedStudent">
              <span class="blue--text">{{ selectedStudent.firstName }}</span
              >,
              <span style="color: #bbb">{{
                selectedStudent.lastName
              }}</span></span
            >
            <span
              class="ml-2"
              v-if="
                userProfile &&
                userProfile.role == 'superadmin' &&
                selectedStudent
              "
              >{{ selectedStudent.ref.path }}</span
            >
          </h3>
        </v-col>
        <v-col v-if="studentScores && studentScores.length > 0">
          <h3 class="red--text font-weight-bold">
            {{ studentScores.length }} xичээлийн дүн
          </h3>
        </v-col>
      </v-row>
      <v-row justify="center" class="mb-16">
        <v-col cols="12" sm="6">
          <v-text-field
            v-model.trim="searchWord"
            autofocus
            label="Сурагчийн нэр эсвэл код оруулаад xайx товчийг дараx"
            clearable
          ></v-text-field>
        </v-col>
        <v-col cols="2">
          <v-btn
            color="primary"
            elevation="0"
            class="mt-2 ml-n4"
            @click="_searchStudent"
            >Xайx</v-btn
          >
        </v-col>
      </v-row>
    </v-card>
    <v-card style="height: 800px; overflow-y: auto" v-if="noStudentFound" class="mt-1">
      <v-card-text>
        <v-row justify="end">
        <v-col cols="4" class="text-end">
          <v-btn @click="_printTodorhoilolt" color="#e33371" dark>Тодорxойлолт</v-btn>
        </v-col>
      </v-row>
      </v-card-text>
      <v-data-table
        v-if="studentScores"
        :headers="headers"
        :items="studentScores"
        :items-per-page="-1"
      >
        <template slot="item" slot-scope="props">
          <tr>
            <td>{{ props.item.index }}</td>
            <td v-if="userProfile && userProfile.email == 'granditxxk@gmail.com'">
              {{ props.item.ref.path }}
            </td>

            <td>
              <span v-if="props.item.lesson">{{ props.item.lesson.name }}</span>
              <span class="font-weight-bold">
                ({{ props.item.lessonCode.toUpperCase() }})
              </span>
            </td>

            <td>{{ props.item.score70 }}</td>
            <td>{{ props.item.score30 }}</td>
            <td>{{ props.item.scoreTotal }}</td>
            <td>{{ props.item.semesterName }}</td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
    <v-card height="300" v-else>
      <v-row
        ><v-col cols="12">
          <p class="text-center" style="color: red">
            Оюутан олдоогүй, эсвэл даxин xайx!
          </p>
        </v-col></v-row
      >
    </v-card>
  </v-container>
</template>
  
  <script>
import { mapState } from "vuex";
import moment from "moment";
import { domainToASCII } from "url";
const fb = require("@/firebaseConfig.js");

export default {
  name: "SearchScores",
  data: () => ({
    noStudentFound: null,
    selectedStudent: null,
    searchWord: null,
    studentScores: null,
    headers: [
      {
        text: "No.",
        align: "start",
        sortable: true,
        value: "index",
        width: "1%",
      },
      {
        text: "Xичээлийн код",
        align: "start",
        sortable: true,
        value: "lessonCode",
        width: "20%",
      },
      {
        text: "70 оноо",
        align: "start",
        sortable: true,
        value: "score70",
        width: "20%",
      },
      {
        text: "30 оноо",
        align: "start",
        sortable: true,
        value: "score30",
        width: "20%",
      },
      {
        text: "Дүн",
        align: "start",
        sortable: true,
        value: "scoreTotal",
        width: "20%",
      },
      {
        text: "Семестр",
        align: "start",
        sortable: true,
        value: "semesterName",
        width: "20%",
      },
    ],
  }),
  components: {},
  props:{},
  computed: {
    ...mapState(["userProfile", "currentUser"]),
    yyschool() {
      return fb.yyschool;
    },
  },
  created() {},
  watch: {
    searchWord(val) {
      if (val == null) {
        this.searchWord = val;
        this.studentScores = val;
        this.selectedStudent = val;
      }
    },
  },
  methods: {
    _printTodorhoilolt() {
      fb.db
        .doc(this.userProfile.ref.path)
        .get()
        .then((doc) => {
          let student = doc.data();
          student.ref = doc.ref;
          student.id = doc.id;
          this.$router.push({
            name: "TodorhoiloltDetail2",
            params: {
              itemRefPath:
                "schools/YJHjHWUGDok8teDhDIKX/xtodorhoilolt/pSPBHDgvioTxO1efDFnh",
              student: this.selectedStudent,
            },
          });
        });
    },
    _searchStudent() {
      if (this.searchWord && this.searchWord.length > 0) {
        fb.db
          .collection(fb.yyschool + "/students")
          .where("studentCode", "==", this.searchWord.toLowerCase())
          .limit(1)
          .get()
          .then((docs) => {
            this.studentScores = [];
            if (!docs.empty) {
              let student = docs.docs[0].data();
              student.id = docs.docs[0].id;
              student.ref = docs.docs[0].ref;

              if (student && student.studentCode) {
                this.selectedStudent = student;
                this._searchStudentScore1(student.studentCode);
                // this._searchStudentScore2(student.id);
              }
              this.noStudentFound = true;
            }
          });
      }
    },
    _searchStudentScore1(studentCode) {
      fb.db
        .collectionGroup("yearScores")
        .where("studentCode", "==", studentCode)
        .onSnapshot((querySnapshot) => {
          var counter = 0;
          querySnapshot.forEach(async (doc) => {
            let score = doc.data();
            score.ref = doc.ref;
            score.id = doc.id;
            score.index = ++counter;
            console.log(score.lessonCode);
            var datas = await fb.db
              .collection("/schools/YJHjHWUGDok8teDhDIKX/lessons-standards/")
              .where("code", "==", score.lessonCode)
              .limit(1)
              .get();
            if (!datas.empty) {
              var doc = datas.docs[0];
              if (doc != null && doc.exists) {
                score.lesson = doc.data();
              }
            } else {
              // this.accessOK = false
            }
            console.log(score);
            this.studentScores.push(score);
          });
          if (querySnapshot.empty) {
            this.errorMessage = "No Score!";
          }
        });
    },
    _searchStudentScore2(studentCode) {
      fb.db
        .collectionGroup("yearScores")
        .where("id", "==", studentCode)
        .onSnapshot((querySnapshot) => {
          var counter = 0;
          querySnapshot.forEach(async (doc) => {
            let score = doc.data();
            score.ref = doc.ref;
            score.id = doc.id;
            score.index = ++counter;
            console.log(score.lessonCode);

            if (score.lessonCode) {
              var datas = await fb.db
                .collection("/schools/YJHjHWUGDok8teDhDIKX/lessons-standards/")
                .where("code", "==", score.lessonCode)
                .limit(1)
                .get();
              if (!datas.empty) {
                var doc = datas.docs[0];
                if (doc != null && doc.exists) {
                  score.lesson = doc.data();
                }
              } else {
                // this.accessOK = false
              }
            }

            this.studentScores.push(score);
          });
          if (querySnapshot.empty) {
            this.errorMessage = "No Score!";
          }
        });
    },
  },
};
</script>
  